import { Box, Flex, Heading } from "@chakra-ui/react";
import { UsersTable } from "../../components/users-table/users-table.comp";

export function UsersList() {

    return (
        <Box p={4}>
            <Flex>
                <Heading as={'h1'}>Users</Heading>
            </Flex>
            <UsersTable showAddButton={true} />
        </Box>
    );
}
